import React from 'react';

import { ErrorContainer, ErrorMessageWrapper, ErrorHeader, ErrorText } from './response-error.styled';
import ErrorImage from './error-image';

const UniqueLinkError = () => {
  return (
    <ErrorMessageWrapper>
      <ErrorContainer>
        <ErrorImage />
        <ErrorHeader>You already filled this form</ErrorHeader>
        <ErrorText>
          <p>You can only fill this form once.</p>
        </ErrorText>
      </ErrorContainer>
    </ErrorMessageWrapper>
  );
};

export default UniqueLinkError;
